(function() {
  var tooltip;

  tooltip = exports;

  tooltip.create = function(el, e, options) {
    var defaults, k, kStr, ref, v, vStr;
    if (e == null) {
      e = null;
    }
    if (options == null) {
      options = {};
    }
    if (!(el instanceof jQuery)) {
      el = $(el);
    }
    if (el.parents().is('#map_canvas')) {
      return false;
    }
    if (el.is('[data-original-title]')) {
      ref = el[0];
      for (k in ref) {
        v = ref[k];
        if (k.indexOf('jQuery') === 0) {
          kStr = k.replace('jQuery', '');
          vStr = v.toString();
          if (kStr.match(/[0-9]+/)[0] === kStr && vStr.match(/[0-9]+/)[0] === vStr) {
            return;
          }
        }
      }
    }
    defaults = {
      delay: {
        show: 500,
        hide: 200
      }
    };
    if (el.parents().is('.scrolling-table tbody>tr:first-child')) {
      defaults.placement = 'bottom';
    }
    options = $.extend(defaults, options);
    el.tooltip(options);
    if (e != null) {
      e.stopPropagation();
      return el.trigger(e.type);
    }
  };

}).call(this);
